import _default from "@fullcalendar/daygrid";

export default function EntityFingerprint({
    guid,
    extended = false
}) {
    return <small className="text-muted"> <i className="fa-solid fa-fingerprint text-eh"></i> {extended ? guid : guid.substr(guid.length - 8)}</small>
}